import React from 'react';

import InviteTeamForm from './InviteTeamForm';
import TeamMemberList from './TeamMemberList';

import './invite.scss';

const Invite = () => {
  return (
    <div className="invite-wrapper">
      <InviteTeamForm />
      <TeamMemberList />
    </div>
  );
};

export default Invite;
